<template>
    <kgr-lightbox
        :value="show"
        :headline="$t('Hinweis')"
        scrollable
        @post-input="$emit('close')"
    >
        <div class="kgr-text">
            <span v-if="invoice && !wasDunningEmailAlreadySent">
                {{ $t('Möchtest du das Mahndokument #{invoiceNumber} an {recipientName} per Mail versenden?', { invoiceNumber: invoice.number, recipientName: invoice.invoiceRecipient.name }) }}
            </span>
            <span v-if="invoice && wasDunningEmailAlreadySent">
                {{ $t('Möchtest du das Mahndokument #{invoiceNumber} an {recipientName} wirklich erneut per Mail versenden?', { invoiceNumber: invoice.number, recipientName: invoice.invoiceRecipient.name }) }}
            </span>
        </div>
        <template #footer>
            <button
                class="kgr-button"
                @click="$emit('close')"
            >
                {{ $t('cancel') }}
            </button>
            <button
                class="kgr-button kgr-button--accent"
                @click="$emit('confirm')"
            >
                {{ $t('Ok') }}
            </button>
        </template>
    </kgr-lightbox>
</template>

<script>
import ClubInvoice from '../../../js/dto/ClubInvoice.js';
import Lightbox from '../../common/modal/Lightbox.vue';

export default {
    components: {
        'kgr-lightbox': Lightbox,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        invoice: {
            type: ClubInvoice,
            default: null,
        },
        dunningLevel: {
            type: Number,
            default: null,
        },
        dunningLevelLabel: {
            type: String,
            default: '',
        },
    },
    emits: ['close', 'confirm'],
    computed: {
        wasDunningEmailAlreadySent() {
            if (!this.invoice || this.dunningLevel === null) {
                return false;
            }
            const dunningPdf = this.invoice.dunningPdfs[this.dunningLevel];
            return dunningPdf && dunningPdf.lastEmailSent !== null;
        },
    },
};
</script>
